import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Hard-coded credentials
const VALID_CREDENTIALS = {
  username: 'jiamusi',
  password: 'jiamusi123',
};

interface AuthState {
  isAuthenticated: boolean;
  username: string | null;
  error: string | null;
  
  // Actions
  login: (username: string, password: string) => boolean;
  logout: () => void;
  clearError: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      username: null,
      error: null,

      login: (username: string, password: string) => {
        // Validate credentials
        if (
          username === VALID_CREDENTIALS.username &&
          password === VALID_CREDENTIALS.password
        ) {
          set({
            isAuthenticated: true,
            username,
            error: null,
          });
          return true;
        } else {
          set({
            isAuthenticated: false,
            username: null,
            error: '用户名或密码错误',
          });
          return false;
        }
      },

      logout: () => {
        set({
          isAuthenticated: false,
          username: null,
          error: null,
        });
      },

      clearError: () => {
        set({ error: null });
      },
    }),
    {
      name: 'auth-storage', // localStorage key
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        username: state.username,
      }),
    }
  )
);
